__turbopack_context__.v({
  "anchor": "tooltip-module__AMpqwa__anchor",
  "tip": "tooltip-module__AMpqwa__tip",
  "tip-in-down": "tooltip-module__AMpqwa__tip-in-down",
  "tip-in-up": "tooltip-module__AMpqwa__tip-in-up",
});
